import { CreateOnboardingInfoDto } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const postOnboardingInfo = async (
  payload: ApiRequest<CreateOnboardingInfoDto>
) => {
  const resp = await api.post<string, CreateOnboardingInfoDto>(
    `/v2/organizations/onboarding-info`,
    payload.body
  );
  return resp.data;
};

export const usePostOnboardingInfo = () => {
  return useMutation<string, Error, ApiRequest<CreateOnboardingInfoDto>, any>({
    mutationFn: async (data) => postOnboardingInfo(data),
  });
};
